import React from "react";

import "./herosection.css";
import Container from "../Container/Container";


const HeroSection = () => {
    function scrollToContact() {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return <Container>
        <section className="hero-section" id="home">
            <div className="hero-image-container">
                <div className="hero-image">
                    <img src="hero.jpg" alt="Dustin Graham" />
                    <div className="status-indicator">
                        <span className="status-dot"></span>
                        <span className="status-text">Open to Work</span>
                    </div>
                </div>
            </div>

            <div className="hero-details">

                <h1 className="title">Dustin Graham</h1>

                <p className="subtitle software-engineer">Software Engineer</p>

                <p className="bio">Hi, I’m Dustin Graham, a full-stack software engineer specializing in scalable web platforms and serverless architectures. I build high-performance applications with TypeScript, React, and AWS, turning complex ideas into solutions that make an impact. I love creating things and solving problems, and outside of work, I stay active with calisthenics and exploring the outdoors.</p>

                <button className="button" onClick={scrollToContact}>Contact Me</button>
            </div>
        </section>
    </Container>;
};



export default HeroSection;